import {AfterViewInit, ChangeDetectorRef, Component, input, OnDestroy, signal, ChangeDetectionStrategy} from '@angular/core';
import {WaCalloutDirective, WaIconDirective, WaToastService} from "angular-awesome";
import {AuthService} from "../../api/services/auth.service";
import {SurveyService} from "../../api/services/survey.service";
import {Subscription} from "rxjs";
import {User} from "../../api/models/user";
import {StatisticsPanelComponent} from "./statistics-panel/statistics-panel.component";
import {ParameterSetEditorComponent} from "./parameter-set-editor/parameter-set-editor.component";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [WaCalloutDirective, WaIconDirective, StatisticsPanelComponent, ParameterSetEditorComponent]
})
export class DashboardComponent implements OnDestroy, AfterViewInit {

  surveyId = input.required<number>();
  // signals to hold survey data and loading/error state
  survey = signal<import('../../api/models/survey').Survey | null>(null);
  loading = signal(false);
  error = signal<string | null>(null);
  user: User | null = null;

  private userSub: Subscription;

  constructor(private authService: AuthService, private surveyService: SurveyService, private toastService: WaToastService, private cd: ChangeDetectorRef) {

    this.userSub = this.authService.loggedInUser$.subscribe({
      next: user => this.user = user, error: _err => {
        this.toastService.danger('Could not fetch current user.');
      }
    });
  }

  ngOnDestroy(): void {
    this.userSub.unsubscribe();
  }

  async ngAfterViewInit(): Promise<void> {
    const id = this.surveyId?.();
    if (id == null) return;
    this.loading.set(true);
    this.error.set(null);
    try {
      const s = await this.surveyService.get(id);
      this.survey.set(s);
    } catch (err: any) {
      const msg = err?.message ?? String(err);
      this.error.set(msg);
      this.toastService.danger(`Failed to load survey ${id}: ${msg}`);
      this.survey.set(null);
    } finally {
      this.loading.set(false);
      try {
        this.cd.detectChanges();
      } catch (_) {
      }
    }
  }

}
